/* =========================================================
   src/services.jsx
   ========================================================= */

const SERVICES = [
  {
    icon: "LineChart",
    title: "Business Consultancy",
    body: "Clear strategy for high-pressure decisions - cutting through complexity, exposing opportunities, and turning ambition into execution.",
  },
  {
    icon: "RefreshCcw",
    title: "Specialists Outsourcing",
    body: "Senior talent on demand - stepping into critical roles fast, solving bottlenecks, and keeping projects moving at full speed.",
  },
  {
    icon: "MonitorSmartphone",
    title: "Digital Transformation",
    body: "Replace slow, fragmented operations with connected digital systems built for speed, scale, and real business impact.",
  },
  {
    icon: "LayoutGrid",
    title: "System Architecture",
    body: "Technology foundations engineered to perform under pressure - secure, scalable, and ready for whatever comes next.",
  },
  {
    icon: "Gauge",
    title: "Process Optimization",
    body: "We uncover what slows your business down, remove friction, and turn inefficient workflows into smooth, measurable performance.",
  },
];

function Services() {
  return (
    <section id="services">
      <div className="wrap">
        <div className="sec-head">
          <div>
            <div className="sec-tag">Services</div>
            <h2 className="sec-title">What we <em>do</em> for you.</h2>
          </div>
          <div className="sec-aside">
            Five core practices, working side by side to turn messy processes, disconnected systems, 
            and slow operations into technology that drives the business forward.
          </div>
        </div>

        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              className="svc"
              data-hover
            >
              <div className="svc-num">{String(i + 1).padStart(2, "0")}</div>
              <div className="svc-icon"><Icon name={s.icon} size={22} strokeWidth={1.8} /></div>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

Object.assign(window, { Services });
